var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"event-calendar",class:{ 'event-calendar--thunderdome': _vm.brand === 'thunderdome' }},[(_vm.hasConfig)?_c('div',{staticClass:"event-calendar__heading-wrapper"},[(_vm.$te('page.home.title'))?_c('h1',{staticClass:"event-calendar__heading"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('page.home.title', { brand: _vm.brand.toUpperCase() }))+"\n\t\t")]):_vm._e(),_vm._v(" "),(_vm.$te('page.home.lead'))?_c('div',{staticClass:"event-calendar__body",domProps:{"innerHTML":_vm._s(_vm.$t('page.home.lead'))}}):_vm._e()]):_c('div',{staticClass:"event-calendar__heading-wrapper"},[_c('p',{staticClass:"event-calendar__body"},[_vm._v(_vm._s(_vm.$t('error.no_config_found')))])]),_vm._v(" "),_c('Grid',_vm._l((_vm.data),function(item,index){return _c('Column',{key:index + item.slug,staticClass:"event-calendar__item"},[_c('EventCalendarItem',{attrs:{"data":{
					slug: item.slug,
					...item.festivalData,
					eventDateTimeFormat: item.eventDatetimeFormat,
					membersale: item.membersale,
					travelsale: item.travelsale,
					preregistration: item.preregistration,
					queueUrl: item.queueUrl,
					url: !item.slug && item.url,
					isComingSoonItem: item.isComingSoonItem,
					comingSoonData: item.isComingSoonItem ? item : null,
					showEventEndsOn: item.showEventEndsOn ? item.showEventEndsOn : false,
					shopTheme: item.shopTheme
				}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }